import React from 'react';
import MainLayout from '../utilities/layouts/MainLayout';
import { connect } from 'react-redux';
import { makeStyles, Typography } from '@material-ui/core';
import { PageTitleBlock } from '../utilities/commonUtilities/GenericDivElements';
import { useHistory } from 'react-router-dom';
import { CardList, CardItem, EmptyItem, MobileHomeButton } from '../utilities/commonUtilities/CardItem';
import { ReactComponent as HistoryBadge } from '../../resources/images/history-badge.svg';
import { ReactComponent as HistoryEmpty } from '../../resources/images/history-empty.svg';
import { PATH_NOTES } from '../../containers/RoutePaths';
import { NotesConsumer } from './NotesConsumer';
import { RequiresLogin } from '../utilities/commonUtilities/RequiresLogin';
import clsx from 'clsx';
import { useBigHeaderTextStyles } from '../LoadingErrorPage';
import { styleBreakMobile } from '../utilities/layouts/Globals';

const isWatchman = process.env.REACT_APP_THEME_ENV === 'watchman';
const emptyNoteHistoryMessage = 'The doctor\'s note you receive after each virtual visit will be saved here.';

const useStyles = makeStyles(theme => ({
    largeText: {
        fontSize: theme.spacing(5),
        [styleBreakMobile(theme)]: {
            fontSize: theme.spacing(4),
        },
    }
}));

const SubtitleText = isWatchman ? () => {
    const classes = useBigHeaderTextStyles();
    const classesLocal = useStyles();

    return (
        <>
            <Typography variant="h1" className={clsx(classes.boldHeaderText, classes.marginTop, classesLocal.largeText)}>
                Sorry,
            </Typography>
            <Typography className={clsx(classes.boldHeaderText, classes.marginTop, classesLocal.largeText)} variant="h1">
                No{' '}
                <Typography component="span" variant="h1" className={clsx(classes.boldHeaderText, classes.colorVariant, classesLocal.largeText)}>
                    Notes
                </Typography>
                {' '}Found.
            </Typography>
        </>
    );
} : 'No Notes Found';

const NoteHistory = ({ allOutcomes }) => {
    return (
        <RequiresLogin>
            <MainLayout>
                <NotesConsumer>
                    {allOutcomes.length > 0 && (
                        <PageTitleBlock>
                            <Typography variant="h1">Notes</Typography>
                        </PageTitleBlock>
                    )}
                    <FollowUpNoteCards allOutcomes={allOutcomes} />
                </NotesConsumer>
            </MainLayout>
            {allOutcomes.length === 0 && <MobileHomeButton />}
        </RequiresLogin>
    );
};

function FollowUpNoteCards({ allOutcomes = [] }) {
    const history = useHistory();

    return allOutcomes.length > 0 ? (
        <CardList style={{ padding: '2px' }}>
            {allOutcomes.map(item => {
                return (
                    <CardItem
                        key={item.id}
                        Badge={HistoryBadge}
                        title={isWatchman ? "Doctor's Note" : 'Follow-up Note'}
                        subtitle={item.receivedDate}
                        onClick={() => handleCardClick(item, history)}
                    />
                );
            })}
        </CardList>
    ) : (
        <EmptyItem
            image={HistoryEmpty}
            title={SubtitleText}
            message={emptyNoteHistoryMessage}
            hideNavbar={isWatchman}
            isFullscreen={isWatchman}
            showShadow={isWatchman} />
    );
}

function handleCardClick(note, history) {
    history.push(`${PATH_NOTES}/${note.id}`);
}

const mapStateToProps = state => {
    return {
        loading: state.outcomes?.loading,
        allOutcomes: state.outcomes?.notes,
    };
};

export default connect(mapStateToProps)(NoteHistory);
